<template>
  <v-bottom-sheet v-model="isOpen" scrollable max-width="100%">
    <v-card>
      <chart-details-content
        :details="details"
        content-style="max-height: 60vh; overflow-y: auto;"
        @close="handleClose"
      >
        <template v-slot:content>
          <slot name="content"></slot>
        </template>
      </chart-details-content>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import ChartDetailsContent from "./ChartDetailsContent.vue";

export default {
  name: "ChartDetailsBottomSheet",
  components: {
    ChartDetailsContent,
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.isOpen = newVal;
      },
      immediate: true,
    },
    isOpen(newVal) {
      this.$emit("input", newVal);
      if (!newVal) {
        this.$emit("close");
      }
    },
  },
  methods: {
    handleClose() {
      this.isOpen = false;
    },
  },
};
</script>
